import React from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ searchTerm, handleSearchChange, scrollToLastPosition }) => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
    scrollToLastPosition();
  };

  const handleSearch = (e) => {
    handleSearchChange(e); // Update the search term
    navigate("/"); // Navigate to the home page
  };

  return (
    <header className="App-header">
      <div className="Title" onClick={goHome}>
        Sous Chef For Tandoor
      </div>
      <div className="SearchBar">
        <input
          type="text"
          placeholder="Search recipes..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>
    </header>
  );
};

export default Header;
